import React from "react";
import { Seo } from "@/components/Seo";
import { useContent } from "@/lib/api";
import { NotFound } from "@/pages/SimplePages";
import NAVIGATION from "@/data/navigation.json";
import { guideRegiesHtml, fichesActives, TITRE_SEO } from "@/lib/guideRegies.mjs";
import "@/styles/guide-regies.css";

/* Le corps de la page vient du même fabricant que le prérendu : le DOM après
   JavaScript est celui du HTML servi, au caractère près. */
export default function GuideRegiesPage() {
  const { data } = useContent();
  if (!data) return null;
  const reglage = data.settings?.guide_regies;
  if (!reglage) return <NotFound />;
  const html = guideRegiesHtml(reglage, fichesActives(data), NAVIGATION.ctas_guide);
  return (
    <>
      <Seo
        title={TITRE_SEO}
        description={reglage.meta_description}
        path={NAVIGATION.guide_regies.to}
        noindex={reglage.publie !== true}
      />
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </>
  );
}
